let signingOut = false;

export default {
  isSigningOut: () => signingOut,
  beginSigningOut: () => {
    signingOut = true;
  },
  reset: () => {
    signingOut = false;
  },
};
